module.exports = __webpack_public_path__ + "public/images/cooking-background-pattern.c8cc28938e07f704d9bcb1f84b6adb2f.svg";